import { getTopPersonalizationInfo } from './getTopPersonalizationInfo';
const getPersonalizationObject = (localStorageName, defaultValue = {}) => {
  const stringValue = localStorage.getItem(localStorageName) || JSON.stringify(defaultValue);
  let pointsForCat = defaultValue;
  try {
    pointsForCat = JSON.parse(stringValue);
  } catch (parseError) {
    console.log(`error parsing ${stringValue} into JSON, removing ${localStorageName}`);
    localStorage.removeItem(localStorageName);
  }
  return pointsForCat;
};
const getPointsForCategoryId = (categoryId) => {
  return getPersonalizationObject(`personalization${categoryId}`, {});
};

const getFavoritedBrandsByCategoryid = (categoryId) => {
  return getPersonalizationObject(`myFavoritespersonalization${categoryId}`, []);
};

const savePersonalizationPointsToDatabaseIfThresholdMeet = (wasParms) => {
  const toSaveObj = getPersonalizationObject('personalizationToSave');
  const totalPointValue = Object.keys(toSaveObj).reduce((runningTotal, superCatObj) => {
    Object.keys(toSaveObj[superCatObj]).forEach((type) => {
      Object.values(toSaveObj[superCatObj][type]).forEach((pointValue) => (runningTotal += pointValue));
    });
    return runningTotal;
  }, 0);
  if (totalPointValue >= wasParms?.personalizationPointsUpdateThreshold) {
    savePersonalizationPointsToDatabase(wasParms);
  }

  const aYearFromNow = new Date();
  aYearFromNow.setFullYear(aYearFromNow.getFullYear() + 1);
  var topPersonalizationInfo = getTopPersonalizationInfo('ALL', this.props.passedAppFunctions.wasParms);
  Cookies.remove('preferredSplash');
  if (topPersonalizationInfo.favoriteSuperCat == '445') {
    Cookies.set('preferredSplash', '/c/men?splashRedirect=true', {
      path: '/',
      expires: aYearFromNow,
    });
  } else if (topPersonalizationInfo.favoriteSuperCat == '430') {
    Cookies.set('preferredSplash', '/c/juniors?splashRedirect=true', {
      path: '/',
      expires: aYearFromNow,
    });
  }
};

const updatePersonalizationStorage = (wasParms, categoryIdToTrack, key, count = 1, storageKeyPrefix) => {
  const localStorageNameForCat = `${storageKeyPrefix}${categoryIdToTrack}`;
  const lsPersonalization = getPersonalizationObject(localStorageNameForCat, {});
  lsPersonalization[key] = lsPersonalization[key] ? lsPersonalization[key] + count : count; //If the brand is already tracked, add to existing points, else create the entry
  localStorage.setItem(localStorageNameForCat, JSON.stringify(lsPersonalization));
  try {
    const toSaveObj = getPersonalizationObject('personalizationToSave', {});
    //Set up the supercat if it doesnt exist
    if (!toSaveObj[categoryIdToTrack]) {
      toSaveObj[categoryIdToTrack] = { brand: {} };
    }
    //if we dont have the brand the create it, otherwise add to its existing count
    if (!toSaveObj[categoryIdToTrack].brand[key]) {
      toSaveObj[categoryIdToTrack].brand[key] = count;
    } else {
      toSaveObj[categoryIdToTrack].brand[key] = toSaveObj[categoryIdToTrack].brand[key] + count;
    }
    localStorage.setItem(`personalizationToSave`, JSON.stringify(toSaveObj));
  } catch (e) {
    console.log(e);
  }
  savePersonalizationPointsToDatabaseIfThresholdMeet(wasParms);
};

const savePersonalizationPointsToDatabase = (wasParms, rebuildLocalStoragePoints = true) => {
  try {
    const emailAddress = Cookies.get('personalizationEmail');
    if (emailAddress) {
      const toSaveObj = getPersonalizationObject('personalizationToSave', {});
      localStorage.removeItem('personalizationToSave');
      //remove all the old personalization categories so we can refresh them with the service's response
      wasParms?.personalizationCategoryIds?.split('|')?.forEach((catgroupIdToTrackAs) => {
        localStorage.removeItem(`personalization${catgroupIdToTrackAs}`);
        if (!rebuildLocalStoragePoints) {
          localStorage.removeItem(`myFavoritespersonalization${catgroupIdToTrackAs}`);
        }
      });
      if (Object.keys(toSaveObj).length > 0) {
        fetch('/wcs/resources/store/301/personalization/points/add', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'omit',
          body: JSON.stringify({ emailAddress, points: toSaveObj }),
        })
          .then((response) => response.json())
          .then((data) => {
            if (rebuildLocalStoragePoints) {
              const points = data?.response?.points;
              Object.keys(points).forEach((catgroupId) => {
                const brand = points[catgroupId]?.brand;
                localStorage.setItem(`personalization${catgroupId}`, JSON.stringify(brand));
              });
            }
          })
          .catch((e) => console.log(e));
      }
      updateBrandFavorites();
    }
  } catch (e) {
    console.log(e);
  }
  return true;
};

// Async function to fetch and process brand favorites
const updateBrandFavorites = async () => {
  try {
    const response = await fetch('/wcs/resources/store/301/myFavoriteBrands', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      cache: 'no-cache',
    });
    if (!response.ok) {
      throw new Error(`Network response was not ok: ${response.statusText}`);
    }
    const data = await response.json();
    if (typeof data === 'object' && data.response.Favorite.length > 0) {
      const categories = data.response.Favorite;
      categories.forEach((category) => {
        const categoryID = category.categoryNum;
        localStorage.setItem(`myFavoritespersonalization${categoryID}`, JSON.stringify(category.brands));
      });
    }
  } catch (error) {
    console.error('Error fetching brand favorites:', error);
    await logError(error.message);
  }
};

const logError = async (errorData) => {
  try {
    let userInfo = Cookies.get('userInfo') ? JSON.parse(Cookies.get('userInfo')) : null;
    const errorToSend = [
      {
        eventType: 'call myFavoriteBrands',
        eventText: 'call failed',
        eventData: {
          error: errorData,
          userId: userInfo !== null ? userInfo.userId : 'null',
        },
      },
    ];
    await fetch(window.location.protocol + '//' + window.location.host + '/wcs/resources/store/301/logging/info', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(errorToSend),
      credentials: 'omit',
    });
  } catch (e) {
    console.error('Failed to log error:', e);
  }
};

export {
  savePersonalizationPointsToDatabase,
  updatePersonalizationStorage,
  getPointsForCategoryId,
  getFavoritedBrandsByCategoryid,
};
